import { render, staticRenderFns } from "./NationalTrademark.vue?vue&type=template&id=42e81365&"
import script from "./NationalTrademark.vue?vue&type=script&lang=js&"
export * from "./NationalTrademark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports